import React, { useState, useEffect, useCallback  } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import { IntlGetText } from "util/IntlMessages";
import InfoCard from "components/InfoCard";
import PanhematinDialog from "./Dialog";
import { callActionApi, getPanhematinInfo } from "api/apiList";
import { callStartImpact } from "actions/Impact";

const Panhematin = () => {
    const dispatch = useDispatch();
  const readOnlyImpactView = useImpactReadOnly();
    const { selectedPrescription } = useSelector(({ management }) => management);
    const { impactStartDate, consentSigned, isCIRequired } =
        useSelector(({ impact }) => impact);

    const [open, setOpen] = useState(false);
    const [panhematinInfo, setPanhematinInfo] = useState([]);

    const msgConsentRequired = IntlGetText("impact.consentRequired");

    const handleClickOpen = () => {
        if (openImpactBoxIfReadOnly(readOnlyImpactView, () => setOpen(true))) return;
        if (!impactStartDate) {
            dispatch(callStartImpact(true));
            return;
        }
        if (isCIRequired && !consentSigned) {
            NotificationManager.warning(msgConsentRequired);
            return;
        }
        setOpen(true);
    };

    const callApi = (apiFunc, setData) => {
        callActionApi(
            apiFunc,
            setData,
            (error) => {
                if (typeof error === "string") NotificationManager.error(error);
            }
        );
    };

    const loadPanhematin = () => {
        callApi(
            () => getPanhematinInfo(selectedPrescription.id),
            (data) => {
                setPanhematinInfo(data);
            }
        );
    };

  const handleRequestClose = () => setOpen(false);
    
    return (
        <div>
            <InfoCard
                data={{
                    icon: "hospital",
                    title: IntlGetText("panhematin.cardTitle"),
                    subTitle: IntlGetText("ledaga.cardSubTitle"),
                    color: "#757575",
                }}
                onClickBox={handleClickOpen}
            />
            <PanhematinDialog
                open={open}
                handleRequestClose={handleRequestClose}
                loadPanhematin={loadPanhematin}
                disableBackdropClick={true}
                panhematinInfo={panhematinInfo}
            />
        </div>
    );
};

export default Panhematin;
